module.exports = __webpack_public_path__ + "img/left1.ef8d69f2.png";